import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxury%20fashion%20editorial%20flat%20lay%20with%20neutral%20beige%20linen%20fabric%20draped%20artfully%20across%20a%20minimalist%20oak%20table%2C%20scattered%20almond%20blossoms%20and%20dried%20pampas%20grass%20for%20organic%20texture%2C%20one%20elegant%20leather%20notebook%20and%20gold%20pen%2C%20warm%20golden%20hour%20sunlight%20streaming%20through%20sheer%20curtains%2C%20soft%20diffused%20shadows%2C%20Scandinavian%20interior%20aesthetic%2C%20clean%20sophisticated%20composition&width=1800&height=1200&seq=hero-mulebuy-v3&orientation=landscape"
          alt="Mulebuy Spreadsheet fashion and lifestyle products organized neatly"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="container-custom">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
            <div className="flex-1 text-center lg:text-left pt-24 lg:pt-0">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
                The Ultimate Mulebuy<br />
                <span className="text-accent-300">Spreadsheet Resource Hub</span>
              </h1>
              <p className="mt-6 text-base md:text-lg text-background-100/80 leading-relaxed max-w-xl">
                Discover everything about the Mulebuy Spreadsheet — tutorials, comparisons, templates, and advanced tracking systems designed for smarter data management and business scaling.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 text-sm font-semibold rounded-md hover:bg-accent-600 transition-all whitespace-nowrap font-label flex items-center justify-center gap-2 group"
                >
                  Mulebuy Spreadsheet
                  <span className="w-5 h-5 flex items-center justify-center border border-background-50/40 rounded-full group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </a>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-8 py-3.5 bg-primary-700 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-800 transition-all whitespace-nowrap font-label flex items-center justify-center gap-2 group"
                >
                  Buy It Now
                  <span className="w-5 h-5 flex items-center justify-center border border-background-50/40 rounded-full group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </a>
              </div>
            </div>

            <div className="hidden lg:block flex-1">
              <div className="relative w-full aspect-[4/5] max-w-md mx-auto rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20still%20life%20featuring%20a%20single%20beautifully%20folded%20cashmere%20sweater%20in%20warm%20beige%20tone%20draped%20over%20a%20modern%20wooden%20surface%2C%20soft%20morning%20light%20creating%20gentle%20highlights%2C%20clean%20cream%20background%2C%20editorial%20catalog%20aesthetic%2C%20luxury%20minimal%20product%20photography%2C%20peaceful%20composition&width=900&height=1125&seq=hero-side-v3&orientation=portrait"
                  alt="Premium Mulebuy Spreadsheet resource hub product showcase"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}